import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

export const LPFooter = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-gray-300">
      {/* Logo & Contact Info in Same Row */}
      <div className="border-b border-gray-700">
        <div className="container mx-auto px-4 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 items-start">
            {/* Logo - Left Side */}
            <div>
              <Link to="/lp" className="flex items-center">
                <img src="/logo-white.png" alt="Trademark Infinite" className="h-12 w-auto" />
              </Link>
            </div>

            {/* Call Us */}
            <div className="text-center md:text-left">
              <div className="flex items-center justify-center md:justify-start gap-2 mb-3">
                <Phone size={20} className="text-orange-500" />
                <h4 className="text-base font-semibold text-white">Call Us</h4>
              </div>
              <a 
                href="tel:+18882016668" 
                className="text-sm text-gray-400 hover:text-orange-500 transition-colors"
              >
                +1 (888) 201-6668
              </a>
            </div>

            {/* Email Us */}
            <div className="text-center md:text-left">
              <div className="flex items-center justify-center md:justify-start gap-2 mb-3">
                <Mail size={20} className="text-orange-500" />
                <h4 className="text-base font-semibold text-white">Email Us</h4>
              </div>
              <a 
                href="mailto:info@trademarkinfinite.com" 
                className="text-sm text-gray-400 hover:text-orange-500 transition-colors"
              >
                info@trademarkinfinite.com
              </a>
            </div>

            {/* Location */}
            <div className="text-center md:text-left">
              <div className="flex items-center justify-center md:justify-start gap-2 mb-3">
                <MapPin size={20} className="text-orange-500" />
                <h4 className="text-base font-semibold text-white">Location</h4>
              </div>
              <p className="text-sm text-gray-400">
                One Wilshire Building<br />
                624 S Grand Ave Floor 21<br />
                Los Angeles, CA 90017
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="bg-gray-900 py-6">
        <div className="container mx-auto px-4">
          <div className="flex flex-col items-center gap-4">
            {/* Copyright & Legal Links */}
            <div className="flex flex-col md:flex-row items-center gap-2 md:gap-4">
              <p className="text-gray-500 text-sm text-center">
                © 2026 Trademark Infinite. All rights reserved.
              </p>
              <div className="flex items-center gap-2">
                <Link 
                  to="/privacy-policy" 
                  className="text-sm text-gray-400 hover:text-orange-500 transition-colors"
                >
                  Privacy Policy
                </Link>
                <span className="text-gray-600">|</span>
                <Link 
                  to="/terms-of-service" 
                  className="text-sm text-gray-400 hover:text-orange-500 transition-colors"
                >
                  Terms of Service
                </Link>
              </div>
            </div>

            {/* Disclaimer */}
            <p className="text-xs text-gray-500 text-center">
              Trademark registration services provided by licensed attorneys.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
